import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

// Get Landing Page Data (GET)
export const getLandingPage = createAsyncThunk('landingPage/getAll', async () => {
  const response = await $axios.get('/landing-page');
  return response.data;
});

// Update Landing Page (PUT)
export const updateLandingPage = createAsyncThunk('landingPage/update', async (data) => {
  const response = await $axios.put('/landing-page', data);
  return response.data;
});

// CRUD for Menus
export const createMenu = createAsyncThunk('landingPage/menu/create', async (data) => {
  const response = await $axios.post('/landing-page/menu', data);
  return response.data;
});

export const updateMenu = createAsyncThunk('landingPage/menu/update', async ({ menuId, data }) => {
  const response = await $axios.patch(`/landing-page/menu/${menuId}`, data);
  return response.data;
});

export const updateMenuList = createAsyncThunk('landingPage/menu/updateList', async (data) => {
  const response = await $axios.put('/landing-page/menu', { menus: data });
  return response.data;
});

export const deleteMenu = createAsyncThunk('landingPage/menu/delete', async (menuId) => {
  const response = await $axios.delete(`/landing-page/menu/${menuId}`);
  return response.data;
});

// CRUD for Banners
export const createBanner = createAsyncThunk('landingPage/banner/create', async (data) => {
  const response = await $axios.post('/landing-page/banners', data);
  return response.data;
});

export const updateBanner = createAsyncThunk('landingPage/banner/update', async ({ bannerId, data }) => {
  const response = await $axios.patch(`/landing-page/banners/${bannerId}`, data);
  return response.data;
});

export const deleteBanner = createAsyncThunk('landingPage/banner/delete', async (bannerId) => {
  const response = await $axios.delete(`/landing-page/banners/${bannerId}`);
  return response.data;
});

// CRUD for Display Categories
export const createDisplayCategory = createAsyncThunk('landingPage/displayCategory/create', async (data) => {
  const response = await $axios.post('/landing-page/display-categories', data);
  return response.data;
});

export const deleteDisplayCategory = createAsyncThunk('landingPage/displayCategory/delete', async (categoryId) => {
  const response = await $axios.delete(`/landing-page/display-categories/${categoryId}`);
  return response.data;
});

// CRUD for Sections
export const createSection = createAsyncThunk('landingPage/section/create', async (data) => {
  const response = await $axios.post('/landing-page/sections', data);
  return response.data;
});

export const updateSections = createAsyncThunk('landingPage/sections/update', async (data) => {
  const response = await $axios.put(`/landing-page/sections`, { sections: data });
  return response.data;
});

export const updateSection = createAsyncThunk('landingPage/section/update', async ({ sectionId, data }) => {
  const response = await $axios.patch(`/landing-page/sections/${sectionId}`, data);
  return response.data;
});

export const deleteSection = createAsyncThunk('landingPage/section/delete', async (sectionId) => {
  const response = await $axios.delete(`/landing-page/sections/${sectionId}`);
  return response.data;
});

export const resetAllData = createAsyncThunk('landingPage/reset', async () => {
  return 'hello world';
});

// Redux Slice
const landingPageSlice = createSlice({
  name: 'landingPage',
  initialState: {
    landingPageValue: null,
    landingPageLoading: false,
    menus: [],
    banners: [],
    displayCategories: [],
    sections: [],
    error: null,
    menuCreated: false,
    menuUpdated: false,
    menuDeleted: false,
    bannerCreated: false,
    bannerUpdated: false,
    bannerDeleted: false,
    displayCategoryCreated: false,
    displayCategoryDeleted: false,
    sectionCreated: false,
    sectionUpdated: false,
    sectionDeleted: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLandingPage.pending, (state) => {
        state.landingPageLoading = true;
        state.landingPageValue = null;
        state.menuCreated = false;
        state.menuUpdated = false;
        state.menuDeleted = false;
        state.bannerCreated = false;
        state.bannerUpdated = false;
        state.bannerDeleted = false;
        state.displayCategoryCreated = false;
        state.displayCategoryDeleted = false;
        state.sectionCreated = false;
        state.sectionUpdated = false;
        state.sectionDeleted = false;
      })
      .addCase(getLandingPage.fulfilled, (state, action) => {
        state.landingPageLoading = false;
        state.landingPageValue = action.payload.data;
        state.menus = action.payload.data.menu;
        state.banners = action.payload.data.banners;
        state.displayCategories = action.payload.data.displayCategories;
        state.sections = action.payload.data.sections;
      })
      .addCase(getLandingPage.rejected, (state, action) => {
        state.landingPageLoading = false;
        state.error = action.error.message;
      })
      .addCase(updateLandingPage.fulfilled, (state, action) => {
        state.landingPageValue = action.payload;
      })
      .addCase(createMenu.pending, (state) => {
        state.menuCreated = false;
      })
      .addCase(createMenu.fulfilled, (state) => {
        state.menuCreated = true;
      })
      .addCase(updateMenuList.pending, (state) => {
        state.menuUpdated = false;
      })
      .addCase(updateMenuList.fulfilled, (state) => {
        state.menuUpdated = true;
      })
      .addCase(updateMenu.pending, (state) => {
        state.menuUpdated = false;
      })
      .addCase(updateMenu.fulfilled, (state) => {
        state.menuUpdated = true;
      })
      .addCase(deleteMenu.pending, (state) => {
        state.menuDeleted = false;
      })
      .addCase(deleteMenu.fulfilled, (state) => {
        state.menuDeleted = true;
      })
      .addCase(createBanner.pending, (state) => {
        state.bannerCreated = false;
      })
      .addCase(createBanner.fulfilled, (state) => {
        state.bannerCreated = true;
      })
      .addCase(updateBanner.pending, (state) => {
        state.bannerUpdated = false;
      })
      .addCase(updateBanner.fulfilled, (state) => {
        state.bannerUpdated = true;
      })
      .addCase(deleteBanner.pending, (state) => {
        state.bannerDeleted = false;
      })
      .addCase(deleteBanner.fulfilled, (state) => {
        state.bannerDeleted = true;
      })
      .addCase(createDisplayCategory.pending, (state) => {
        state.displayCategoryCreated = false;
      })
      .addCase(createDisplayCategory.fulfilled, (state) => {
        state.displayCategoryCreated = true;
      })
      .addCase(deleteDisplayCategory.pending, (state) => {
        state.displayCategoryDeleted = false;
      })
      .addCase(deleteDisplayCategory.fulfilled, (state) => {
        state.displayCategoryDeleted = true;
      })
      .addCase(createSection.pending, (state) => {
        state.sectionCreated = false;
      })
      .addCase(createSection.fulfilled, (state) => {
        state.sectionCreated = true;
      })
      .addCase(updateSection.pending, (state) => {
        state.sectionUpdated = false;
      })
      .addCase(updateSection.fulfilled, (state) => {
        state.sectionUpdated = true;
      })
      .addCase(updateSections.pending, (state) => {
        state.sectionUpdated = false;
      })
      .addCase(updateSections.fulfilled, (state) => {
        state.sectionUpdated = true;
      })
      .addCase(deleteSection.pending, (state) => {
        state.sectionDeleted = false;
      })
      .addCase(deleteSection.fulfilled, (state) => {
        state.sectionDeleted = true;
      })
      .addCase(resetAllData.fulfilled, (state) => {
        state.menuCreated = false;
        state.menuUpdated = false;
        state.menuDeleted = false;
        state.bannerCreated = false;
        state.bannerUpdated = false;
        state.bannerDeleted = false;
        state.displayCategoryCreated = false;
        state.displayCategoryDeleted = false;
        state.sectionCreated = false;
        state.sectionUpdated = false;
        state.sectionDeleted = false;
      });
  },
});

export default landingPageSlice.reducer;
